export default "__VITE_ASSET__BgnsVwTQ__"